import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { shareReplay, switchMapTo } from 'rxjs/operators';
import { PaymentParams, WebcallSummary } from '../../account/account.model';
import { Moment } from 'moment';
import { CustomQueryEncoderHelper } from '../CustomQueryEncoderHelper';

export interface FullConfig {
  data: boolean;
}

@Injectable()
export class AccountService {
  configChanged = new Subject<boolean>();
  public accountConfiguredData$: Observable<FullConfig>;
  isAccountSet$ = new Subject();

  constructor(private http: HttpClient) {
    this.accountConfiguredData$ = this.getIsFullyConfigured();
  }

  getIsFullyConfigured(): Observable<FullConfig> {
    return this.isAccountSet$.pipe(switchMapTo(this.fetchIsFullyConfigured()), shareReplay(1));
  }

  fetchIsFullyConfigured(): Observable<FullConfig> {
    return this.http.get<FullConfig>('/account/msisdn-fully-configured');
  }

  getAccountConfig(): Observable<FullConfig> {
    return this.accountConfiguredData$;
  }

  changeAccountConfig(configured: FullConfig) {
    this.configChanged.next(configured.data);
    this.accountConfiguredData$ = this.http.get<FullConfig>('/account/msisdn-fully-configured').pipe(shareReplay(1));
  }

  getBalance() {
    return this.http.get('/finance/balance');
  }

  getCard() {
    return this.http.get('/finance/card');
  }

  getPaymentStatus(key) {
    return this.http.get(`/finance/payment?paymentIntentId=${key}`);
  }

  getCurrentSubscriptionPaymentStatus(): Observable<PaymentParams> {
    return this.http.get<PaymentParams>(`/finance/subscription/payment`);
  }

  getSubscriptionParams() {
    return this.http.get(`/finance/subscription`);
  }

  getUser() {
    return this.http.get(`/users/current`);
  }

  getAccountStats() {
    return this.http.get('/account/stats');
  }

  getWebcallSummary(since: Moment): Observable<WebcallSummary> {
    let params = new HttpParams({ encoder: new CustomQueryEncoderHelper() });
    params = params.set('since', since.format());

    return this.http.get<WebcallSummary>('/account/webcall', { params });
  }
}
